export default "__VITE_ASSET__JQVCdiXz__"